<!-- 此组件已废弃 -->
<template>
  <div>
    <a-tabs class="tabs bg01" v-model="activeKey"  @tabClick="f1" id="tab-content" v-if="enabledAutoProject">
      <a-tab-pane  key="1" tab="方案配置">
        <project-index></project-index>
      </a-tab-pane>
      <a-tab-pane  key="2" tab="数据采集">
        <data-index></data-index>
      </a-tab-pane>
    </a-tabs>
    <data-index v-else></data-index>
  </div>
</template>

<script>
  import DataIndex from './index/DataIndex'
  import {  mapGetters } from 'vuex'
  import {getRoleList} from '@/api/manage'
  import ProjectIndex from './index/ProjectIndex'
  export default {
    name: 'Index',
    components: { ProjectIndex, DataIndex },
    data(){
      return {
        activeKey:'1',
        enabledAutoProject:window._CONFIG.enabledAutoProject
      }
    },
    methods:{
      ...mapGetters(["userInfo"]),
      f1(cur){
        const content = document.querySelector('#tab-content');
        if(cur === '1'){
          content.classList.add('bg01')
        }else{
          content.classList.remove('bg01')
        }
      }
    }
  }
</script>

<style scoped lang="less">
.tabs{
  min-height: calc(100vh - 62px);
  /deep/ .ant-tabs-tab{
    color: #2b5e7d;
  }
}
.bg01{
  background-image: url(~@/assets/bg01.png);
  background-size: cover;
}

</style>